// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-395df4ac],textarea[data-v-395df4ac],ul[data-v-395df4ac]{color:var(--field-text-color,var(--color-waterloo));padding-bottom:.5em;padding-top:.5em}label[data-v-395df4ac]{pointer-events:none}textarea[data-v-395df4ac]{border-bottom:1px solid}textarea[data-v-395df4ac]:focus{outline:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
